export const dynamicTitle = (title) => {
  return (document.title = title);
};
